import { createAsyncThunk } from '@reduxjs/toolkit';

import { NewsService } from 'api';

import { MarkNewsItemProps } from 'models';

export const getPieceOfNews = createAsyncThunk(
	'news/getPieceOfNews',
	async (params: MarkNewsItemProps) => {
		return await NewsService.getPieceOfNews(params);
	},
);
